// Logged-in pinch scale. Matches the iOS Home gesture: a remembered
// multiplier from 0.8 to 1.6, stacked on top of the Appearance text size.
// Appearance stays on the root rem. This scale is separate.

export const CONTENT_SCALE_KEY = 'peopleiknow-content-scale';
export const MIN_CONTENT_SCALE = 0.8;
export const MAX_CONTENT_SCALE = 1.6;
export const HERO_SCALE_CAP = 1.15;

export function clampContentScale(value) {
  const n = Number(value);
  if (!Number.isFinite(n)) return 1;
  return Math.min(MAX_CONTENT_SCALE, Math.max(MIN_CONTENT_SCALE, n));
}

export function roundContentScale(value) {
  return Math.round(clampContentScale(value) * 100) / 100;
}

export function heroContentScale(value) {
  return Math.min(clampContentScale(value), HERO_SCALE_CAP);
}

export function readContentScale(storage = globalThis.localStorage) {
  try {
    const raw = storage?.getItem(CONTENT_SCALE_KEY);
    if (raw == null || raw === '') return 1;
    return roundContentScale(raw);
  } catch {
    return 1;
  }
}

export function writeContentScale(value, storage = globalThis.localStorage) {
  const next = roundContentScale(value);
  try {
    storage?.setItem(CONTENT_SCALE_KEY, String(next));
  } catch {
    /* private mode */
  }
  return next;
}

export function pinchDistance(a, b) {
  const dx = a.clientX - b.clientX;
  const dy = a.clientY - b.clientY;
  return Math.hypot(dx, dy);
}

// e.scale on iOS is the ratio since the gesture began, applied to the
// scale that was already saved.
export function nextPinchScale(base, startDistance, currentDistance) {
  const start = Number(startDistance);
  const current = Number(currentDistance);
  if (!Number.isFinite(start) || start <= 0 || !Number.isFinite(current)) {
    return roundContentScale(base);
  }
  return roundContentScale(Number(base) * (current / start));
}

// Appearance (0.9, 1, 1.15, 1.3) times the pinch. The greeting uses the
// 1.15 cap. Chrome that must stay put uses the appearance size alone.
export function stackedTextScale(appearanceScale, contentScale, { hero = false } = {}) {
  const appearance = Number(appearanceScale);
  const base = Number.isFinite(appearance) && appearance > 0 ? appearance : 1;
  const content = clampContentScale(contentScale);
  return base * (hero ? heroContentScale(content) : content);
}
